import React, { useContext, useEffect } from "react";
import {Link, Navigate, useParams} from "react-router-dom";
import API from "../../API";
import Context from "../../context";
import Filter from "../test-creator/Filter";
import HeaderTest from '../test-creator/HeaderTest';
import Score from "../test-creator/Score";
import { ru } from "../../data/ru";
import { by } from "../../data/by";
import '../test-creator/test-creator.css'
import {ReturnTextAndImg} from "../../test/CheckImg";
import { useState } from "react";
import ComplexTaskTexts from "./ComplexTaskTexts";
import ComplexTaskQuestions from "./ComplexTaskQuestions.jsx";
import {TASK_CREATOR_URL, TEXT_CREATOR_URL} from "../../../config";
import Loader from "../../layouts/Loader";
import TasksTextsView from "../TasksTextsView";

export default function ComplexTaskCreator() {
  let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdThree: by.RoleIdThree;
  const { mainState,isLoading,setIsLoading } = useContext(Context)

  const api = new API();

  let { id } = useParams();

  const [questions, setQuestions] = useState([])
  const [filters, setFilters] = useState([])
  const [visibleData, setVisibleData] = useState([])
  const [userFilters, setUserFilters] = useState([])
  const [testData, setTestData] = useState([])
  const [scores, setScores] = useState({})
  const [headerTest, setHeaderTest] = useState({})
  const [isQuestionsOpen, setIsQuestionsOpen] = useState(false)
  const [isTextsOpen, setIsTextsOpen] = useState(false)
  const [texts, setTexts] = useState([])
  const [testDataTexts, setTestDataTexts] = useState([])
  const [defaultHeader,setDefaultHeader] = useState(null)

  const getAllData=()=>{
    setIsLoading(true)
    api.getQuestions().then(data => {
      if(!data) {
        return
      }
      setQuestions(questions => {
        return [
          ...data.questions,
        ]
      })
      setVisibleData(data.questions)
      setIsLoading(false)
    })

    api.getTexts().then(data => {
      if(!data) {return}
      setTexts(data)
      // setTexts([{id:1, text: 'fffff'}, {id:2, text:'rrrr'}])
    })

    api.getFilters().then(data => {
      setFilters(filters => {
        return {
          ...data,
        }
      })
    })
  }
  const getTask=(id)=>{
    api.getComplexTask(id).then(data=> {
          setTestData(data.questions)
          setTestDataTexts(data.texts)
      setDefaultHeader({
        name:data.name,
        description:data.description,
      })
        }
    )
  }
  useEffect(() => {
    if(id){
      getTask(id)
    }
    getAllData()
  }, [])


  function changeUserFilters(filter) {
    if (filter !== '' && !userFilters.includes(filter)) {
      setUserFilters(userFilters => {
        return [
          ...userFilters,
          filter,
        ]
      })
    }
  }

  function findQuestionsByFilters(list, tags) {
    const questionWithFilters = list.filter(item => {
      for (let i = 0; i < tags.length; i++) {
        if (!item.tags.includes(+tags[i])) {
          return false
        }
      }
      return true
    })
    setVisibleData(questionWithFilters)
  }

  function addText(textObj) {
    setTestDataTexts(testDataTexts => {
      return [...testDataTexts, textObj]
    })
  }

  function addQuestion(q) {
    setTestData(testData => {
      return [...testData, q]
    })
  }

  function changeScores(id, value) {
    setScores(scores => {
      return {
        ...scores, [id]: value
      }
    })
  }

  function deleteQuestionFromTest(e, id) {
    setTestData(testData => {
      return testData.filter(item => item.id !== id)
    })
  }
  function deleteTextFromTest(e, id) {
    setTestDataTexts(TestDataTexts=>{
      return TestDataTexts.filter(item => item.id !== id)
    })
  }

  function editQuestion(questionId) {
    window.location.href = TASK_CREATOR_URL+questionId
    // window.sessionStorage.clear();
    // window.sessionStorage.setItem('idQuestionToEdit-1', questionId)
  }
  function editText(textId) {
    window.location.href = TEXT_CREATOR_URL+textId
  }
  function deleteQuestion(question) {
    let isOk = window.confirm('Вы уверенны, что хотите удалить вопрос?');
    if(isOk) {
      api.deleteQuestion(question.id)
      setVisibleData(visibleData => {
        return visibleData.filter(item => item.id !== question.id)
      })
      setQuestions(questions => {
        return questions.filter(item => item.id !== question.id)
      })
    }
  }
  
  function deleteText(text) {
    let isOk = window.confirm('Вы уверенны, что хотите удалить вопрос?');
    if(isOk) {
      api.deleteText(text.id)
      setTexts(texts => {
        return texts.filter(item => item.id !== text.id)
      })
      // setQuestions(questions => {
      //   return questions.filter(item => item.id !== text.id)
      // })
    }
  }

  let showQuestions = visibleData.map(item => {
    if (testData.find(el => el.id === item.id)) {
      return null
    }
    const text = ReturnTextAndImg(item.description,{maxHeight: '30px', maxWidth:'50px'})

    return <TasksTextsView key={`visible${item.id}`} item={item} add={addQuestion} edit={editQuestion} deleteI={deleteQuestion} text={text} textTitle="Вопрос:"/>
  })

  let textsJSX = texts.map((item,i) => {
    if(testDataTexts.find(el => el.id === item.id)) {
      return null
    }
    const text = ReturnTextAndImg(item.text,{maxHeight: '30px', maxWidth:'50px'})
    const newText = <div><div>{item.title}</div><div>{text}</div></div>

    return <TasksTextsView key={item.id+i} item={item} add={addText} edit={editText} deleteI={deleteText} textTitle="Текст:" text={newText}/>
  })

  function addHeaderTest(requestOptions) {
    setHeaderTest(requestOptions)
  }

  function sendTask(requestOptions) {
    const resultTexts = testDataTexts.map(item => {
      return item.id
    })

    const resultQuestions = testData.map((item, i) => {
      return {
        idQuestion: item.id,
        order: i + 1,
        score: scores[item.id]
      }
    })

    let api = new API()
    if(!id){
      api.addComplexTask(requestOptions, resultTexts, resultQuestions)
    }
    else{
      api.editComplexTask(id,{...requestOptions,questions:[...resultQuestions],texts:[...resultTexts]})
    }
  }


  let showFilters = Object.keys(filters).map(key => {
    return <Filter key={`filter${key}`} kategory={key} filters={filters[key]} changeUserFilters={changeUserFilters} />
  })

  function deleteUserFilter(id) {
    setUserFilters(userFilters.filter(item => +item !== id))
  }

  let showUserFilters = userFilters.length > 0 ? userFilters.map(userFilterId => {
    let result = []
    Object.keys(filters).forEach(filterName => {
      return(filters[filterName].find(item => {
        if(item.id === +userFilterId) {
          result.push(<p style={{display: 'flex', alignItems: 'center'}} key={`usrfilter${item.id}`} onClick={() => deleteUserFilter(item.id)}>{item.name} <span style={{fontSize: '25px', color: 'red'}}>&times;</span></p>)
        }
      }))
    }) 
    return <div key={`userfilter${userFilterId}`}>{result}</div>
  }) : null

  function upQuestionFunction(index) {
    if (index !== 0) {
      setTestData((prevQuestions) => {
        const arrQuestions = [...prevQuestions];
        const prevItem = arrQuestions[index - 1];//предыдущий элемент, который будем заменять
        arrQuestions[index - 1] = arrQuestions[index];
        arrQuestions[index] = prevItem;
        return arrQuestions;
      });
    }  }

  function downQuestionFunction(index) {
    if (index !== testData.length - 1) {
      setTestData((prevQuestions) => {
        const arrQuestions = [...prevQuestions];
        const nextItem = arrQuestions[index + 1]; //следующий элемент, который будем заменять
        arrQuestions[index + 1] = arrQuestions[index];
        arrQuestions[index] = nextItem;
        return arrQuestions;
      });
    }
  }


  function upTextFunction(index) {
    if (index !== 0) {
      setTestDataTexts((prevQuestions) => {
        const arrQuestions = [...prevQuestions];
        const prevItem = arrQuestions[index - 1];//предыдущий элемент, который будем заменять
        arrQuestions[index - 1] = arrQuestions[index];
        arrQuestions[index] = prevItem;
        return arrQuestions;
      });
    }  }

  function downTextFunction(index) {
    if (index !== testDataTexts.length - 1) {
      setTestDataTexts((prevQuestions) => {
        const arrQuestions = [...prevQuestions];
        const nextItem = arrQuestions[index + 1]; //следующий элемент, который будем заменять
        arrQuestions[index + 1] = arrQuestions[index];
        arrQuestions[index] = nextItem;
        return arrQuestions;
      });
    }
  }

  if(isLoading){
    return <Loader/>
  }
  return (
      mainState.isLoggedIn && (mainState.type === "Editor" ||mainState.type === "Admin")?
        <div className="test-creator-background">
          <div className="test-creator-main"> 
            <div className="test-creator-container">
              <div className="test-creator-filters">
                {showFilters}
                <button onClick={() => findQuestionsByFilters(questions, userFilters)} className="test-creator-filters-button">{language.createTestButtonFind}</button>
              </div>
              <div className="test-creator-user-filters">{showUserFilters}</div>
              <hr className="test-creator-container-separator" />

              <div style={{display:'flex'}}>
                <div className={!isQuestionsOpen?'test-creator-complex-button':'test-creator-complex-button-active' } onClick={() => setIsQuestionsOpen(prev => !prev)}>{language.questions}</div>
                <div className={!isTextsOpen?'test-creator-complex-button':'test-creator-complex-button-active'} onClick={() => setIsTextsOpen(prev => !prev)}>{language.texts}</div>
              </div>

              <div className="test-creator-constructor">
                {isQuestionsOpen && 
                <div className="test-creator-questions">
                  {showQuestions}
                </div>}

                {isTextsOpen &&
                  <div className="test-creator-questions">
                    {textsJSX}
                  </div>
                }

                <div className="test-creator-test">
                  <HeaderTest addHeaderTest={addHeaderTest} name={defaultHeader?.name} description={defaultHeader?.description} />
                  <ComplexTaskTexts texts={testDataTexts}
                                    deleteT={deleteTextFromTest}
                                    upFunction={upTextFunction}
                                    downFunction={downTextFunction}

                  />
                  <ComplexTaskQuestions questions={testData}
                                        deleteQ={deleteQuestionFromTest}
                                        changeScores={changeScores}
                                        downFunction={downQuestionFunction}
                                        upFunction={upQuestionFunction}
                  />

                  <button className="test-creator-button-send" onClick={() => sendTask(headerTest)} disabled={!Boolean(testData.length)}>{language.sendButton}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        : <Navigate to="/*" />
      
  )
}